import { useEffect, useState, useContext } from "react";
import { Footer, Header } from "../../components";
import { useTranslation } from "react-i18next";
import "./styles.css";
import { Images } from "../../theme";
import { AuthContext } from "../../context/AuthContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FindMyRoom,
  CreateRoom,
  GetMessages,
  updateData,
} from "../../services/FirebaseCalls";
import moment from "moment";
import { generateItems } from "../../util/genericFunctions";
import _ from "lodash";

export default function InboxChat() {
  const AuthData = useContext(AuthContext);
  const { loginData, imageUrl } = AuthData ? AuthData : null;
  const { t } = useTranslation();
  const uselocation = useLocation();

  const [roomId, setRoomId] = useState(uselocation.state?.roomId || false);
  const [rooms, setRooms] = useState([]);
  const [messages, setMessages] = useState([]);
  const [textValue, setTextvalue] = useState("");
  const [chatUser, setChatUser] = useState(
    uselocation.state?.receiverUser || {}
  );

  useEffect(() => {
    getRooms();
    getMessages();
  }, [roomId, loginData.id]);

  function getMessages() {
    if (!roomId) return;
    GetMessages(
      {
        collectionName: "msg",
        id: roomId,
      },
      function (roomData) {
        let data = [];
        roomData.forEach((e) => {
          data.push({
            id: e.id,
            ...e.data(),
          });
        });
        let reverseWithTime = generateItems(data, true).sort(
          (x, y) => new Date(y.createdAt) - new Date(x.createdAt)
        );
        setMessages(reverseWithTime.reverse());
      }
    );
  }

  function getRooms() {
    FindMyRoom(
      {
        collectionName: "chatRoom",
        id: loginData.id,
      },
      function (roomData) {
        let data = [];
        roomData.forEach((e) => {
          data.push({
            id: e.id,
            ...e.data(),
          });
        });
        let byAccending = data.sort(
          (x, y) => new Date(y.createdAt) - new Date(x.createdAt)
        );
        setRooms(byAccending);
      }
    );
  }

  async function sendMessage() {
    if (!roomId) return;
    const payload = {
      text: textValue,
      type: "text",
      id: roomId,
      senderId: loginData.id,
      receiverId: chatUser.id,
      createdAt: moment(Date.now()).format("MM-DD-YYYY hh:mm:ss a"),
    };
    let check = await CreateRoom({ collectionName: "msg", payload });
    check.id && setTextvalue("");
    await updateData({
      collectionName: "chatRoom",
      id: roomId,
      payload: {
        createdAt: moment(Date.now()).format("MM-DD-YYYY hh:mm:ss a"),
        count: 0
      },
    });
  }

  return (
    <>
      <Header />

      <div className="container">
        <div className="boxShadowChat">
          <div className="row mt-3 mb-3">
            <div className="col-lg-3 col-md-3 col-12 inboxHeadingCountBox">
              <span className="inboxHeadingStyle">{t("Inbox")}</span>
              <span className="inboxHeadingCount">4 {t("New")}</span>
            </div>
            <div className="col-lg-7 col-md-6 col-9 ">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex flex-row align-items-center">
                  <img
                    className="senderImgStyle"
                    src={
                      chatUser.profileImagePath
                        ? `${imageUrl}${chatUser.profileImagePath}`
                        : Images.user
                    }
                  />
                  <div class="d-flex flex-column line-height userNameStyle">
                    <p className="senderNameHeading">
                      {chatUser.firstname} {chatUser.lastname}
                    </p>
                    {/* <p className="senderNameMsg">Last seen recently</p> */}
                  </div>
                </div>{" "}
                <span class="dots"> </span>
              </div>
            </div>
            {/* <div className="col-lg-2 col-md-3 col-3 inboxHeadingCountBox">
              <div className="senderHeaderImgStyleBox">
                <span className="optionStyle">...</span>
              </div>
            </div> */}
          </div>

          <div className="row">
            <div className="col-md-3 heightBox3Style">
              {rooms?.map((val, index) => {
                let userDetail = val.receiverUser?.id == loginData.id ? val.senderUser : val.receiverUser

                return (
                  <a
                    onClick={() => {
                      setRoomId(val.id);
                      setChatUser(userDetail);
                      setMessages([]);
                    }}
                  >
                    <div
                      class="d-flex justify-content-between align-items-center userNameMsfStyle"
                      style={{
                        backgroundColor:
                          chatUser?.id == userDetail?.id
                            ? "#F1F3F9"
                            : "#fff",
                      }}
                    >
                      <div class="d-flex flex-row align-items-center">
                        <img
                          className="senderImgStyle"
                          src={
                            userDetail?.profileImagePath
                              ? `${imageUrl}${userDetail?.profileImagePath}`
                              : Images.user
                          }
                        />
                        <div class="d-flex flex-column line-height userNameStyle">
                          <p className="senderNameHeading">
                            {userDetail?.firstname}
                          </p>
                          {/* <p className="senderNameMsg">Last seen recently</p> */}
                        </div>
                      </div>
                      <div class="d-flex text-center">
                        <div class="d-flex flex-row align-items-end">
                          <div class="d-flex flex-column line-height userNameStyle">
                            <p className="senderNameMsg">
                              {moment(val.createdAt).format("hh:mm a")}
                            </p>
                            {/* {count > 1 ? (
                              <div className="inboxNewMsgStyle">
                                <p className="mb-0">ss</p>
                              </div>
                            ) : null} */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>

            <div className="col-md-9 heightBoxStyle backgroundColorBox">
              {messages?.map((val, index) => {
                if (val.type && val.type === "day") {
                  return (
                    <div className="col-md-12 inboxHeadingDaysBox">
                      <span className="inboxHeadingDays">
                        {moment(val.date).format("MMM DD")}
                      </span>
                    </div>
                  );
                }
                return (
                  <div>
                    {loginData.id == val.senderId ? (
                      <div className="row senderImgStyleBox">
                        <div className="col-lg-8 col-md-6"></div>
                        <div className="col-lg-4 col-md-6 p-0">
                          <div className="row chatStyleBlue">
                            <div className="col-md-12">
                              <span className="MeSenderNameMsg">
                                {val.text}
                              </span>
                              <span className="MedateMsgStyle">
                                {moment(val.createdAt).format("hh:mm a")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-lg-1 col-md-1 col-2">
                          <img
                            className="senderChatImgStyle"
                            src={
                              chatUser.profileImagePath
                                ? `${imageUrl}${chatUser.profileImagePath}`
                                : Images.user
                            }
                          />
                        </div>
                        <div className="col-lg-4 col-md-6 col-10 p-0">
                          <p className="senderNameClient">
                            {chatUser.firstname} {chatUser.lastname}
                          </p>
                          <div className="row chatStyleWhite">
                            <div className="col-md-12">
                              <span className="senderNameMsg">{val.text}</span>
                              <span className="dateMsgStyle">
                                {moment(val.createdAt).format("hh:mm a")}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-7 col-md-5 col-0"></div>
                      </div>
                    )}
                  </div>
                );
              })}

              <div className="row">
                <div className="col-md-12 p-0">
                  <div className="chatingInput">
                    <div className="row">
                      <div className="col-lg-11 col-md-9 col-9">
                        <input
                          type="text"
                          placeholder={t("Write_a_messege")}
                          className="form-control msgCustomInputText"
                          name="name"
                          value={textValue}
                          onChange={(e) => setTextvalue(e.target.value)}
                        />
                      </div>
                      {/* <div className="col-lg-1 col-md-1 col-1 dotMsgIconBoxStyle">
                        <img className="dotIconStyle" src={Images.dotIconNew} />
                      </div> */}
                      <div className="col-lg-1 col-md-1 col-1 sendMsgIconBoxStyle">
                        <img
                          className="sendMsgIconStyle"
                          src={Images.sendMsgIcon}
                          onClick={sendMessage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
